import { render } from "./ReportCarInfo.vue?vue&type=template&id=56aa383a&scoped=true&ts=true"
import script from "./ReportCarInfo.vue?vue&type=script&lang=ts"
export * from "./ReportCarInfo.vue?vue&type=script&lang=ts"

import "./ReportCarInfo.vue?vue&type=style&index=0&id=56aa383a&scoped=true&lang=less"

import exportComponent from "/workspace/source-code/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56aa383a"]])

export default __exports__